import { useLocation } from 'react-router-dom';

import { loadActions } from 'entities';

import { useRealTime, useRealTimeSubscription } from 'providers/RealTime';

import { projectActions } from './projects.data';

export function useProjectRealTimeSync() {
  const { pathname } = useLocation();

  const { loading } = useRealTime();

  const getProjects = loadActions.projects.batchGetProjects.use({
    onMutation: loading.up,
    onEnd: loading.down,

    onSuccess: (projects) => {
      projectActions.setProjects((old) => ({
        ...old,

        ...Object.fromEntries(
          projects.map((project) => [
            project.id,
            {
              ...old[project.id],

              ...project,

              // properties that removal makes sense to keep removed
              addCountryRequest: project?.addCountryRequest || undefined,
              expectedDateRequest: project?.expectedDateRequest || undefined,
              reprice: project?.reprice || undefined,

              // this is to make sure any extra props the user loaded --> will be replaced later
              // before won't be lost (eg comments, logs, etc)
              tasks:
                (old[project.id]?.tasks?.map((task) => {
                  const newData = project.tasks.find(({ id }) => id === task.id);

                  return {
                    ...task,
                    ...newData,
                    // properties that removal makes sense to keep removed
                    // new implementation later will fix this
                    subOwner: newData?.subOwner || undefined,
                    dateChangeRequest: newData?.dateChangeRequest || undefined,
                  };
                }) ||
                  project.tasks) ??
                [],
            },
          ]),
        ),
      }));
    },
  });

  const findTask = loadActions.projects.findTask.use({
    onMutation: loading.up,
    onEnd: loading.down,

    onSuccess: (task) => {
      projectActions.setProjects((old) => ({
        ...old,

        [task.projectId]: {
          ...old[task.projectId],

          tasks: old[task.projectId].tasks.map((t) => (t.id === task.id ? { ...t, ...task } : t)),
        },
      }));
    },
  });

  useRealTimeSubscription('NEW_PROJECT_DATA', (message) => {
    const isTaskRefresh = message.type === 'TASK' && pathname === `/projects/${message.project}`;

    if (isTaskRefresh)
      return findTask.execute({ projectId: message.project, taskId: message.task! });

    getProjects.execute({
      ids: [message.project],
    });
  });

  useRealTimeSubscription('INVOICE_CONTROL_OWNERSHIP_CHANGE', ({ owner, project }) => {
    projectActions.setProjects((old) =>
      old[project]
        ? {
            ...old,

            [project]: {
              ...old[project],

              invoice: {
                ...old[project].invoice,

                owner,
              },
            },
          }
        : old,
    );
  });
}
